import { gql } from "@apollo/client";

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($data: ProductInput!) {
    createProduct(data: $data) {
        id
    }
}
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($data: ProductInput!, $where: ProductWhereInputOne!) {
    updateProduct(data: $data, where: $where) {
        id
    }
}
`;

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($where: ProductWhereInputOne!) {
    deleteProduct(where: $where) {
        id
    }
}
`;

export const CREATE_PRODUCT_AND_STOCKS = gql`
  mutation CreateProductAndStocksMutation($data: ProductAndStocksInput!, $where: ProductAndStocksWhereInput!) {
  createProductAndStocks(data: $data, where: $where) {
    id
  }
}
`;